import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import {trigger, style, animate, transition, keyframes, state, query, group} from '@angular/animations';
import {ApiService} from "../api.service";
import {CommonService} from "../common.service";
import {ActivatedRoute, Router} from "@angular/router";

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-case-practice-cooperation-question',
  animations:[
    trigger('questionShowAnimation', [
      transition('void => *', [
        style({opacity: 0}),
        query('#numberWrap', style({opacity: 0}), {optional:true}),
        query('#questionCard', style({opacity: 0, transform: 'translate(300%)'}), {optional:true}),
        query('#questionBtn', style({opacity: 0}), {optional:true}),
        animate('200ms ease-in', style({opacity: 1})),
        query("#numberWrap", animate('200ms', style({opacity: 1})), {optional:true}),
        group([
          query('#questionCard', animate('500ms', keyframes([
            style({transform: 'translate(200%)', opacity: 1}),
            style({transform: 'translate(150%)', opacity: 1}),
            style({transform: 'translate(100%)', opacity: 1}),
            style({transform: 'translate(80%)', opacity: 1}),
            style({transform: 'translate(60%)', opacity: 1}),
            style({transform: 'translate(40%)', opacity: 1}),
            style({transform: 'translate(20%)', opacity: 1}),
            style({transform: 'translate(0%)', opacity: 1})
          ])), {optional:true}),
          query('#questionBtn', animate('500ms', style({opacity: 1})), {optional:true}),
        ]),
      ]),
      transition('* => void', [
        query('#numberWrap', animate('500ms', style({opacity: 0}))),
        query('#questionCard', animate('500ms', style({opacity: 0}))),
        query('#questionBtn', animate('500ms', style({opacity: 0}))),
      ])
    ]),
    trigger('answerShowAnimation', [
      transition('void => *', animate('500ms', keyframes([
        style({opacity: 0, transform: 'scale(.3)',offset:0}),
        style({opacity: 1, transform: 'scale(1.3)',offset:0.8}),
        style({opacity: 1, transform: 'scale(1)',offset:1})
      ]))),
    ]),
    trigger('correctAnswerShowAnimation', [
      transition('void => *', animate('1.4s', keyframes([
        style({opacity: 0}),
        style({opacity: 0}),
        style({opacity: 0}),
        style({opacity: 0}),
        style({opacity: 0}),
        style({opacity: 0}),
        style({opacity: 0}),
        style({opacity: 0}),
        style({opacity: 0}),
        style({opacity: 0}),
        style({opacity: 0.25}),
        style({opacity: 0.5}),
        style({opacity: 0.75}),
        style({opacity: 1})
      ]))),
    ])
  ],
  templateUrl: './case-practice-cooperation-question.component.html',
  styleUrls: ['./case-practice-cooperation-question.component.css',]
})
export class CasePracticeCooperationQuestionComponent implements OnInit, AfterViewInit {
    @Input() exerciseId:number;
    @Input() practiceId:number;
    @Input() practiceMetaId:number;
    @Input() learningPathId:number;
    @Input() practiceList:any;
    @Input() type: string;
    data: any;
    questions: any;
    currentQuestion: any;
    currentQuestionIndex: number;

    questionBtnMode: number;

    iconShowMode: number;

    optionArray: any;

    seletedOptionArray: any;

    answerShow: string;
  assetsRoute: string = "../../assets";

  constructor(
      private commonService:CommonService,
      private apiService: ApiService,
      private route: ActivatedRoute,
      private router: Router
  ) { }

  ngOnInit() {
      this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
      this.optionArray=[
          {
              option:'【研发】',
              selected: false
          },
          {
              option:'【总装车间】',
              selected: false
          },{
              option:'【供应链】',
              selected: false
          },{
              option:'【售后质量】',
              selected: false
          },
      ];

      this.apiService.ajax({
          'type': 'get',
          'url': '/api/authQuestion/'+this.exerciseId
      }).subscribe(result=>{
            this.data = result;
          this.questions = this.data.questions;
          this.questionInit();
      });

      /*this.apiService.ajax({

          'type':'get',
          'url':'/api/exercises/'+this.exerciseId

      }).subscribe(result=>{

      });*/

      /*this.data = this.getMockData();
      this.questions = this.data.questions;
      this.questionInit();*/
  }

    ngAfterViewInit(){
        this.commonService.initPage({
            'backgroundColor':'white'
        });
    }

    questionInit(){
      if(this.questions.length == this.data.completed.length){
          this.currentQuestionIndex = this.data.completed.length-1;
          this.currentQuestion = this.questions[this.currentQuestionIndex];
          this.questionBtnMode = 3;
          this.iconShowMode = this.data.completed[this.data.completed.length-1].isTrue;
          this.answerShow = this.currentQuestion.answer.split('|').join(' ');
      }else{
          this.currentQuestionIndex = this.data.completed.length;
          this.currentQuestion = this.questions[this.currentQuestionIndex];
          this.questionBtnMode = 1;
          this.seletedOptionArray = [];
          this.iconShowMode = 0;
          this.answerShow = this.currentQuestion.answer.split('|').join(' ');
      }
    }

    optionClick(i){
      if(this.questionBtnMode == 3){
          return;
      }
      let temp = [];
      this.optionArray[i].selected = !this.optionArray[i].selected;
      this.optionArray.forEach(function(item,index){
          if(item.selected){
              temp.push(item.option)
          }
      });
      this.seletedOptionArray = temp;
      if(this.seletedOptionArray.length==0){
          this.questionBtnMode = 1;
      }else{
          this.questionBtnMode = 2;
      }
      // console.log(this.seletedOptionArray.join('|'));
    }

    questionBtnClick(){
      if(this.questionBtnMode == 1){
          return;
      }else if(this.questionBtnMode == 2){
          this.apiService.ajax({
              'type': 'post',
              'url':'/api/authQuestion/'+this.exerciseId,
              'data':{
                  'authquestion_id':this.questions[this.currentQuestionIndex].id,
                  'isTrue': this.currentQuestion.answer == this.seletedOptionArray.join('|') ? 1:2,
                  'answer': this.seletedOptionArray.join('|')
              }
          }).subscribe(result=>{
              this.questionBtnMode = 3;
              // console.log(this.currentQuestion.answer);
              if(this.currentQuestion.answer == this.seletedOptionArray.join('|')){
                  this.iconShowMode = 1;
              }else{
                  this.iconShowMode = 2;
              }
          });
      }else if(this.questionBtnMode == 3){
        if(this.currentQuestionIndex==this.questions.length-1){
            this.apiService.ajax({
                'type':'post',
                'url':'/api/pnoStorePoint/'+this.exerciseId,
                'data':{
                    'pno_store_point_id':15
                }
            }).subscribe(result=>{
                if(this.type){
                  localStorage.setItem('sh',this.type);
                }
                let link = ['case-practice-authorization-main',this.learningPathId,this.practiceId,this.exerciseId];
                this.router.navigate(link);
            });
        }else{
            $("#questionCard").fadeOut(200);
            this.currentQuestionIndex ++;
            this.currentQuestion = this.questions[this.currentQuestionIndex];
            $("#questionCard").fadeIn(200);
            this.questionBtnMode = 1;
            this.seletedOptionArray = [];
            this.optionArray.forEach(function(item,index){
                item.selected = false;
            });
            this.iconShowMode = 0;
            this.answerShow = this.currentQuestion.answer.split('|').join(' ');
        }
      }
    }

    // getMockData(){
    //   return {
    //       "questions": [{
    //           "id": 20,
    //           "title": "\u5728\u7b2c\u4e00\u5468\u7684\u56de\u987e\u4f1a\u8bae\u4e2d\uff0c\u4f60\u63d0\u5230\u57fa\u4e8e\u5e02\u573a\u63a8\u5e7f\u548c\u8425\u9500\u89d2\u5ea6\u7684\u8003\u8651\uff0c\u4e00\u4efd\u53ef\u884c\u6027\u62a5\u544a\u662f\u5fc5\u987b\u7684\uff0c\u4f60\u5e0c\u671b\u6709\u90e8\u95e8\u6765\u8d1f\u8d23\u6b64\u62a5\u544a\u3002",
    //           "answer": "\u3010\u7814\u53d1\u3011",
    //           "options": ["\u3010\u7814\u53d1\u3011", "\u3010\u603b\u88c5\u8f66\u95f4\u3011", "\u3010\u4f9b\u5e94\u94fe\u3011", "\u3010\u552e\u540e\u8d28\u91cf\u3011"]
    //       }, {
    //           "id": 21,
    //           "title": "\u5728\u4f1a\u8bae\u4e2d\uff0c\u4f60\u51fa\u4e8e\u5168\u5c40\u8003\u8651\uff0c\u8fd8\u60f3\u518d\u4e86\u89e3\u4e00\u65e6\u5ba2\u6237\u63d0\u51fa\u9700\u6c42\u540e\uff0c\u6700\u7ec8\u6210\u54c1\u7684\u4ea4\u4ed8\u671f\u662f\u591a\u4e45\uff0c\u4f46\u6b64\u95ee\u9898\u5e76\u672a\u5728\u4f1a\u4e0a\u5f97\u5230\u89e3\u51b3\uff0c\u63a5\u4e0b\u6765\u4f60\u60f3\u5728\u7b2c\u4e8c\u5468\u518d\u6b21\u53ec\u96c6\u76f8\u5173\u4eba\u5458\u5f00\u4e2a\u5c0f\u4f1a\u3002",
    //           "answer": "\u3010\u7814\u53d1\u3011|\u3010\u603b\u88c5\u8f66\u95f4\u3011|\u3010\u4f9b\u5e94\u94fe\u3011",
    //           "options": ["\u3010\u7814\u53d1\u3011", "\u3010\u603b\u88c5\u8f66\u95f4\u3011", "\u3010\u4f9b\u5e94\u94fe\u3011", "\u3010\u552e\u540e\u8d28\u91cf\u3011"]
    //       }, {
    //           "id": 22,
    //           "title": "\u7b2c\u4e8c\u5468\u7684\u4f1a\u8bae\u7531\u4e8e\u79cd\u79cd\u539f\u56e0\u88ab\u63a8\u8fdf\u4e86\uff0c\u4e0e\u6b64\u540c\u65f6\uff0c\u7531\u4e8e\u6218\u7565\u90e8\u8d1f\u8d23\u4eba\u751f\u75c5\uff0c\u4f60\u5c06\u4f5c\u4e3a\u4e3b\u5bfc\uff0c\u5728\u7b2c\u4e09\u5468\u53d1\u8d77\u4e00\u6b21\u7535\u8bdd\u4f1a\u8bae\uff0c\u4e3b\u8981\u8ba8\u8bba\u6574\u8f66\u88c5\u914d\u96f6\u4ef6\u7684\u751f\u4ea7\u6d41\u7a0b\u548c\u4f9b\u5e94\u8ba1\u5212\u6392\u671f\uff0c\u5e76\u5c06\u4f1a\u8bae\u7eaa\u8981\u53d1\u9001\u5404\u76f8\u5173\u90e8\u95e8",
    //           "answer": "\u3010\u603b\u88c5\u8f66\u95f4\u3011|\u3010\u4f9b\u5e94\u94fe\u3011",
    //           "options": ["\u3010\u7814\u53d1\u3011", "\u3010\u603b\u88c5\u8f66\u95f4\u3011", "\u3010\u4f9b\u5e94\u94fe\u3011", "\u3010\u552e\u540e\u8d28\u91cf\u3011"]
    //       }, {
    //           "id": 23,
    //           "title": "\u540c\u65f6\uff0c\u4f60\u8fd8\u51c6\u5907\u5728\u7b2c\u4e09\u5468\u7ec4\u7ec7\u4e00\u6b21\u6c9f\u901a\u4f1a\u8bae\uff0c\u4e3b\u8981\u8ba8\u8bba2\u4e2a\u8bae\u9898\uff1a<br\/>a)\u521d\u6b65\u8ba8\u8bba\uff0c\u5efa\u7acb\u4e2a\u6027\u5316\u6c7d\u8f66\u7684\u4f20\u64ad\u5e73\u53f0\uff0c\u8425\u9020\u826f\u597d\u6d88\u8d39\u4f53\u9a8c<br\/>b)\u8bbe\u7f6e\u5e73\u53f0\u52a9\u624b\uff0c\u5236\u5b9a\u54cd\u5e94\u5ba2\u6237\u95ee\u8be2\u7684\u56de\u590d\u673a\u5236",
    //           "answer": "\u3010\u552e\u540e\u8d28\u91cf\u3011",
    //           "options": ["\u3010\u7814\u53d1\u3011", "\u3010\u603b\u88c5\u8f66\u95f4\u3011", "\u3010\u4f9b\u5e94\u94fe\u3011", "\u3010\u552e\u540e\u8d28\u91cf\u3011"]
    //       }, {
    //           "id": 24,
    //           "title": "\u6218\u7565\u90e8\u7684\u8d1f\u8d23\u4eba\u75c5\u5047\u8fdf\u8fdf\u672a\u5f52\u3002<br\/>\u4e3a\u4e86\u4e0d\u8ba9\u9879\u76ee\u7684\u8fdb\u5ea6\u843d\u540e\uff0c\u4f60\u51b3\u5b9a\u4f9d\u7167\u539f\u5148\u8ba1\u5212\u5728\u7b2c\u56db\u5468\u7ed9\u547c\u53eb\u4e2d\u5fc3\u7684\u5458\u5de5\u7ec4\u7ec7\u57f9\u8bad\uff0c\u4e3b\u8981\u9488\u5bf9\u4e2a\u6027\u5316\u65b9\u6848\u7684\u5ba2\u6237\u5e38\u89c1\u95ee\u9898\u89e3\u7b54\uff0c\u8c01\u6765\u5e2e\u4f60\u505a\u57f9\u8bad",
    //           "answer": "\u3010\u552e\u540e\u8d28\u91cf\u3011",
    //           "options": ["\u3010\u7814\u53d1\u3011", "\u3010\u603b\u88c5\u8f66\u95f4\u3011", "\u3010\u4f9b\u5e94\u94fe\u3011", "\u3010\u552e\u540e\u8d28\u91cf\u3011"]
    //       }],
    //       "concatenation": "\u8ba8\u8bba\u80cc\u666f<br\/><br\/>\u4e00\u4e2a\u6708\u8fc7\u53bb\u4e86\uff0c\u4f60\u4e5f\u4ece\u9879\u76ee\u521d\u671f\u7684\u6fc0\u52a8\u4e2d\u6e10\u6e10\u611f\u53d7\u5230\u4e0d\u4e00\u6837\u7684\u6ecb\u5473\u3002<br\/><br\/>\u90e8\u95e8\u4e0e\u90e8\u95e8\u4e4b\u95f4\u7684\u534f\u4f5c\u4f3c\u4e4e\u5e76\u6ca1\u6709\u4f60\u60f3\u8c61\u7684\u90a3\u6837\u987a\u5229\uff0c\u5f80\u5f80\u662f\u6218\u7565\u90e8\u53ec\u5f00\u7684\u5b9a\u671f\u4f1a\u8bae\u7ed3\u675f\u4ee5\u540e\uff0c\u4e0b\u4e00\u6b21\u95ee\u9898\u56de\u987e\u4f9d\u7136\u6ca1\u6709\u4e1d\u6beb\u8fdb\u5c55\u3002<br\/><br\/>\u4f60\u4f5c\u4e3a\u8425\u9500\u90e8\u95e8\u7684\u9879\u76ee\u8d1f\u8d23\u4eba\uff0c\u51c6\u5907\u91c7\u53d6\u884c\u52a8\uff0c\u5e0c\u671b\u901a\u8fc7\u5efa\u7acb\u826f\u597d\u7684\u4f19\u4f34\u5173\u7cfb\uff0c\u5c06\u65b9\u6848\u7684\u63a8\u8fdb\u53d8\u5f97\u66f4\u52a0\u987a\u5229\u8d77\u6765\u3002<br\/><br\/>\u4f60\u51b3\u5b9a\u5148\u4ece\u7814\u53d1\u90e8\u95e8\u7684\u65b9\u79d1\u79d1\u5f00\u59cb\u3002",
    //       "completed": []
    //   }
    // }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-question/case-practice-cooperation-question.component.ts